"use client";

import { ProviderProps } from "@/types/util";

import { OpenAccountProvider } from "@/context/openAccount";
import { EmailProvider } from "@/context/openAccount/email";
import { SecuritySettingsProvider } from "@/context/util/securitySettings";

export function OpenAccountProviders(props: Pick<ProviderProps, "children">) {
  return (
    <SecuritySettingsProvider>
      <OpenAccountProvider>
        <EmailProvider>{props.children}</EmailProvider>
      </OpenAccountProvider>
    </SecuritySettingsProvider>
  );
}
